import type { CmpHider } from './types';

export const crownpeak: CmpHider = {
  id: 'crownpeak',
  label: 'Crownpeak (Evidon)',
  css: `
      /* Crownpeak Universal Consent Platform (formerly Evidon / "_evidon"): the
         consent UI is injected by Evidon's notice script directly onto <body>.
         The opt-in notice renders as a fixed bottom banner bar "#_evidon_banner"
         (class .evidon-banner, position:fixed, z-index ~2147383) holding the
         message, category links, and Accept/Options buttons; hide that root to
         remove the banner. Some configurations dim the page behind the
         banner/preferences with a separate fixed full-screen backdrop
         "#_evidon_background" (.evidon-background) — hide that too so no faded
         overlay remains. After a choice is made (and on every later visit) the
         platform leaves a persistent fixed floating "Privacy Options" relink
         button on the page: an anchor "#_evh-link" (z-index 2147483600) inside a
         "#_evh-button" wrapper (.evidon-consent-button) appended to <body> — hide
         the wrapper and the link so the icon does not float over the preview. The
         underscore-prefixed "_evidon"/"_evh" ids are specific to the consent UI,
         so this does not touch unrelated page content. Crownpeak does not lock
         page scroll via a body class or inline style on the sites observed; if a
         build does, the html/html-body [style*="overflow"] and
         [style*="position: fixed"] release rules above already out-specify an
         inline overflow/position lock. */
      #_evidon_banner,
      #_evidon-banner,
      .evidon-banner,
      #_evidon_background,
      #_evidon-background,
      .evidon-background,
      #_evh-button,
      #_evh-link,
      .evidon-consent-button { display: none !important; }
  `,
};
